const cities = [
    {
        name: 'city A',
        value: 'cityA',
        districts: [
            {
                name: 'district 1',
                value: 'district1',
            },
            {
                name: 'district 2',
                value: 'district2',
            },
            {
                name: 'district 3',
                value: 'district3',
            },
        ],
    },
    {
        name: 'city B',
        value: 'cityB',
        districts: [
            {
                name: 'district 4',
                value: 'district4',
            },
            {
                name: 'district 5',
                value: 'district5',
            },
            {
                name: 'district 6',
                value: 'district6',
            },
        ],
    },
    {
        name: 'city C',
        value: 'cityC',
        districts: [
            {
                name: 'district 7',
                value: 'district7',
            },
            {
                name: 'district 8',
                value: 'district8',
            },
            {
                name: 'district 9',
                value: 'district9',
            },
        ],
    },
];

export default cities;
